













import { defineComponent, reactive, computed } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import CreatorGroupsQuery from '@/gql/getCreatorGroups.gql';

const CommonCreatorGroupSelector = defineComponent({
  setup(props: any) {
    /* ==== Define creator group ==== */
    const { result: creatorGroupResult, loading } = useQuery(CreatorGroupsQuery);
    const creatorGroups = useResult(creatorGroupResult, [], (data) => data.creatorGroups);
    const computedCreatorGroupName = computed(() => {
      const temp: string[] = [];
      creatorGroups.value.forEach((group: any) => {
        temp.push(group.name);
      });
      return temp;
    });
    const computedCreatorGroupId = computed(() => {
      const temp: string[] = [];
      creatorGroups.value.forEach((group: any) => {
        temp.push(group.id);
      });
      return temp;
    });
    const computedCreatorGroupCode = computed(() => {
      const temp: string[] = [];
      creatorGroups.value.forEach((group: any) => {
        temp.push(`P${group.id} - ${group.name}`);
      });
      return temp;
    });
    // ============================== //

    const _value = computed(() => props.value);

    return {
      computedCreatorGroupId,
      computedCreatorGroupDisplay: props.displayCode ? computedCreatorGroupCode : computedCreatorGroupName,
      loading,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'ประเภทของผู้สร้างสรรค์ผลงาน'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    displayCode: {
      type: Boolean,
      default() { return false; },
    },
  },
});

export default CommonCreatorGroupSelector;
